import { Component, EventEmitter, Input, OnChanges, Output } from "@angular/core";
import { MAT_DATE_FORMATS } from "@angular/material/core";
import { TimeService } from "@app2/shared/services/time.service";
import { DatePickerHeaderComponent } from "@app2/shared/components/date-picker-header.component";

// All string dates in format YYYY-MM-DD
@Component({
    selector: "date-picker",
    template: `
        <div class="date-picker-container">
            <input type="text" [(ngModel)]="dateMoment" (dateChange)="updateDate()" [matDatepicker]="picker"
                   [min]="minMoment" [max]="maxMoment"
                   [placeholder]="placeholder"
                   test-id="date-picker" required/>
            <mat-datepicker-toggle matSuffix [for]="picker" [disableRipple]="true">
                <mat-icon matDatepickerToggleIcon>
                    <span class="far fa-calendar calendar-icon"></span>
                </mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker #picker [calendarHeaderComponent]="datePickerHeader">
            </mat-datepicker>
        </div>
    `,
    providers: [
        {
            provide: MAT_DATE_FORMATS,
            useValue: {
                parse: {
                    dateInput: "YYYY-MM-DD",
                },
                display: {
                    dateInput: "YYYY-MM-DD",
                    monthYearLabel: "MMM YYYY",
                },
            },
        },
    ],
    styles: [`
        .calendar-icon {
            font-size: 1rem;
        }

        :host-context(.cat-policy-date-picker) input {
            width: 72.5%;
            margin-top: 1rem;
        }
    `],
})
export class DatePickerComponent implements OnChanges {
    @Input() date: date;
    @Input() min: date;
    @Input() max: date;
    @Input() placeholder: string = "";
    @Output() dateChange = new EventEmitter<date>();

    dateMoment: Moment;
    minMoment: Moment;
    maxMoment: Moment;
    datePickerHeader = DatePickerHeaderComponent;

    constructor(private readonly timeService: TimeService) {
    }

    ngOnChanges() {
        this.dateMoment = this.timeService.parseLocalDate(this.date, this.timeService.formats.timestampDate);
        this.minMoment = this.timeService.parseLocalDate(this.min, this.timeService.formats.timestampDate).startOf("day");
        this.maxMoment = this.timeService.parseLocalDate(this.max, this.timeService.formats.timestampDate).startOf("day");
    }

    updateDate() {
        this.dateChange.emit(this.dateMoment?.format("YYYY-MM-DD"));
    }
}
